import { integerFormatter } from "../valueFormatters/integerFormatter";
import { numberCellStyle } from "../cellStyles/numberCellStyle";

export const integerColumn = {
  type: "rightAligned",
  enableValue: true,
  valueFormatter: integerFormatter,
  cellStyle: numberCellStyle,
  filter: "agNumberColumnFilter",
  filterParams: {
    buttons: ["reset"],
    inRangeInclusive: true,
  },
};
